"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function buildFacadeClient(classType) {
    var facadeStub = Object.getOwnPropertyNames(classType.prototype).reduce(function (client, method) {
        if (method !== "constructor") {
            var facade_1 = Object.assign(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return facade_1.__actualMethod.apply(facade_1, __spread(args));
            }, { __actualMethod: undefined });
            client[method] = facade_1;
        }
        return client;
    }, {});
    return __assign(__assign({}, facadeStub), { bindClient: function (client) {
            Object.keys(facadeStub).forEach(function (method) {
                facadeStub[method].__actualMethod = client[method];
            });
        } });
}
function createFacadeClients(apis) {
    return Object.keys(apis)
        .concat()
        .reduce(function (acc, apiName) {
        var apiKey = apiName;
        var apiConfig = apis[apiKey];
        acc[apiKey] = buildFacadeClient(apiConfig.class);
        return acc;
    }, {});
}
exports.default = createFacadeClients;
//# sourceMappingURL=facadeClients.js.map